import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { MessageService, PrimeNGConfig } from 'primeng/api';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { DownloadExcelComponent } from 'src/app/module/shared/components/download-excel/download-excel.component';
import { ViewEditCommonComponent } from 'src/app/module/shared/components/view-edit-common/view-edit-common.component';
import { WarehouseService } from 'src/app/module/warehouse/services/warehouse.service';
import { AccessControlService } from 'src/app/shared/services/AccessControl.service';
import { TabService } from 'src/app/shared/tab.service';
import { AddWorklogComponent } from '../add-budget/add-worklog.component';
import { CommonBulkPrintComponent } from 'src/app/module/shared/components/common-bulk-print/common-bulk-print.component';
import { CommonCsvComponent } from 'src/app/module/shared/components/common-csv/common-csv.component';
import { WorklogService } from '../../services/worklog.service';
import { SharedService } from 'src/app/shared/shared.service';
import { SharedTableComponent } from 'src/app/module/shared/components/shared-table/shared-table.component';

@Component({
  selector: 'app-worklog',
  templateUrl: './worklog.component.html',
  styleUrls: ['./worklog.component.css']
})
export class WorklogComponent implements OnInit {
  theme = 'dark'
  pageSize = 50; // Number of items per page
  pageIndex = 0;
  currentPage: number = 1;
  pageNumber = 0;
  sortingCol : string = 'logDate';
  direction : string = 'DESC' 

  warehouseFilter: any = [];
  warehouseData: any = [];
  getWarehouseList: any;
  customerModel: any;
  selectedWarehouse: any;
  storedWarehouse: any;
  clientId: any;
  clientDetails: any;
  ref: DynamicDialogRef | undefined;
  selectedData:  any[]=[];
  editContation: boolean = false;
  filters:any;
  columns = [
    {showColumn: true, isDelete: true, sortingColumn: 'logDate',  key: 'logDate', header: 'Log Date', sortable: true, type: 'dateOnly' },
    {showColumn: true, isDelete: true, sortingColumn: 'projectId',  key: 'projectName', header: 'Project Name', sortable: true, type: 'text' },
    {showColumn: true, isDelete: true, sortingColumn: '',  key: 'title', header: 'Task', sortable: false, type: 'text', viewDialog: false },
    {showColumn: true, isDelete: true, sortingColumn: '',  key: 'convertedLoggedTime', header: 'Logged Time', sortable: false, type: 'text' },
    {showColumn: true, isDelete: true, sortingColumn: '',  key: 'statusDescription', header: 'Status', sortable: false, type: 'text', viewDialog: false },
    {showColumn: true, isDelete: true, sortingColumn: 'employeeId',  key: 'employeeName', header: 'Employee Name', sortable: true, type: 'text' },
    {showColumn: true, isDelete: true, sortingColumn: '',  key: 'taskDescription', header: 'Description', sortable: false, type: 'text', viewDialog: false },
    {showColumn: true, isDelete: true, sortingColumn: 'start',  key: 'start', header: 'Start', sortable: true, type: 'timeOnly' },
    {showColumn: true, isDelete: true, sortingColumn: 'end',  key: 'end', header: 'End', sortable: true, type: 'timeOnly' },
    {showColumn: true, isDelete: true, sortingColumn: '',  key: 'approvedBy', header: 'Approved By', sortable: false, type: 'text' },
    {showColumn: true, isDelete: true, sortingColumn: 'approvedAt',  key: 'approvedAt', header: 'Approved At', sortable: true, type: 'date' },
  ];

  columnsToExport: string[]  = ['financialYear', 'month', 'customer','whType','zone','customerOwned','budgetAmount', 'whName', 'expensesType', 'expensesIncluded', 'associatedUsers', 'totalExpenseAmount', 'budgetType', 'reference', 'budgetProof', 'budgetUpdatedRemark'];

  dropdownOptions: { [key: number]: string[] } = {
    0: ['2023-2024', '2022-2023'],
    1: ['January', 'February', 'March'],
  };

  warehouseList = []; // Define warehouse list here
  accounts = []; // Define account list here
  totalCount = 0;
  @ViewChild(DownloadExcelComponent) downloadExcel!: DownloadExcelComponent;
  @ViewChild(CommonBulkPrintComponent) printData!: CommonBulkPrintComponent;
  @ViewChild(CommonCsvComponent) downloadCsv!: CommonCsvComponent;

  @ViewChild('sharedTable') sharedTable!: SharedTableComponent;
  selectedRows: any[] = [];
  tableLists: any;
  employeeId:any;
  role:any;
  showMyWorklog = false;
  constructor(private WorklogService : WorklogService, 
    private primengConfig: PrimeNGConfig, private fb: FormBuilder, private warehouseService: WarehouseService, private tabService: TabService,private sharedService: SharedService,
    public dialogService: DialogService, private messageService: MessageService, private router: Router, public accessControlService: AccessControlService) {
    this.getWarehouseList = JSON.parse(localStorage.getItem('wareHouseList')!)
    this.accounts = JSON.parse(localStorage.getItem('accountList')!)
    const userDetails = JSON.parse(localStorage.getItem('user_details')!);
    this.role = JSON.parse(localStorage.getItem('role')!);
    this.employeeId = userDetails.id
  }

  ngOnInit(): void {
      // this.getList()
  }

  ngAfterViewInit(){
    
  }
   
  getList() {
    this.tableLists = []
    if(this.role !== "SuperAdmin"){
      const filterData =
        {
          "key": 'USER_ID',
          "value": this.employeeId.toString()
        }
      this.filters.push(filterData)
    }
    this.WorklogService.getWorklogs(this.filters ? this.filters : [], this.pageNumber, this.pageSize,this.sortingCol,this.direction).subscribe((data: any) => {
        if(data){
          this.tableLists = data?.responseObject?.content;
          this.totalCount = data?.responseObject?.totalElements;
          this.selectedData = []
          this.tableLists.forEach((el:any)=>{
            if(el.minutes){
              el.convertedLoggedTime = this.sharedService.convertMinutesToTime(el.minutes)
            }
          })
        }
      },err => {
        // console.log(err);
        this.tableLists = []
      });
  }

  onFilterChange(event: any) {
    if(event){
      this.filters = event
      if(this.filters.length>0){
        this.getList()
      }
      else{
        if(!this.showMyWorklog){
          this.myWorklog()
        }
        else{
          this.getList()
        }
      }
    }
  }

  onResetFilters() {
    this.filters = []
    this.showMyWorklog = false
    if(!this.showMyWorklog){
      this.myWorklog()
    }
    else{
      this.getList()
    }
  }

  paginate(event: any) {
    this.pageNumber = event.pageIndex ? event.pageIndex : 0
    this.pageSize = event.pageSize ? event.pageSize : 50
    if(this.showMyWorklog){
      this.myWorklog()
    }
    else{
      this.getList()
    }
  }
  
  onSortChange(event: { columnKey: string, sortOrder: 'ASC' | 'DESC' }): void {
    this.sortingCol = event.columnKey
    this.direction = event.sortOrder
    if(this.showMyWorklog){
      this.myWorklog()
    }
    else{
      this.getList()
    }
  }

  onSelectedRowsDelete(selectedData:any){
    this.deleteItem(selectedData[0])
  }

  onSelectedRowsChange(selectedRows: any[]) {
    this.selectedRows = selectedRows;
    this.selectedData = [...selectedRows]
    this.editEvent()
    const title = "budget";
    if(this.printData){
      this.printData.data = selectedRows;
    }
    if (this.downloadExcel) {
      this.downloadExcel.data = selectedRows;
      this.downloadExcel.columnsToExport = this.columnsToExport;
      this.downloadExcel.fileName = title;
    }
    if(this.downloadCsv){
      this.downloadCsv.data = selectedRows;
      this.downloadCsv.columnsToExport = this.columnsToExport;
      this.downloadCsv.fileName = title;
    }
     else {
      console.error('DownloadExcelComponent is not initialized.');
    }
  }

  deleteItem(data:any){
    this.WorklogService.deleteWorklogInfo(data.id).subscribe((res:any)=>{
      this.messageService.add({
        severity: 'success',
        summary: 'Success',
        detail: 'Worklog deleted successfully',
      });
      if(!this.showMyWorklog){
        this.myWorklog()
      }
      else{
        this.getList()
      }
    })
  }

  AddWorklog(type:any) {
    this.ref = this.dialogService.open(AddWorklogComponent, {
      header: `${type} Worklog`,
      data: type == 'Add' ? {} : {
        editData : this.selectedData,
        edit: this.editContation
      },
      width: '70vw',
      contentStyle: { overflow: 'auto', position: "top" },
      draggable: true,
      styleClass: 'no-close-icon-dialog',
    });
    this.ref.onClose.subscribe((data: any) => {
      console.log("resss", data)
      this.editContation = false
      if (data) {
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: data?.responseMessage,
        });
      }
      this.getList()
    });
  }

  receiveDataEvent(data: any[]) {
    console.log(data) 
    this.selectedData = data
    this.editEvent()
  }
  editEvent(){
    this.editContation = true
    console.log( this.editContation)
    this.AddWorklog('Edit')
  }
  deleteEvent(){
    // const ids = Array.from(new Set(this.selectedData.map((item: any) => item.id))).join(',');
    // this.emsServices.deleteExpense(ids).subscribe((data: any) => {
    //   if(data){
    //     this.selectedData = [];
    //     this.getList();
    //     this.messageService.add({
    //       severity: 'success',
    //       summary: 'Success',
    //       detail: 'Expense Deleted successfully',
    //     });
    //   }
    //  },err => {
    //   this.tableLists = []
    //  });
  }
  myWorklog(){
    this.showMyWorklog = !this.showMyWorklog
    this.tableLists = []
    if(this.showMyWorklog){
      this.filters = [
        {
          "key": 'USER_ID',
          "value": this.employeeId.toString()
        }
      ]
    }
    else{
      this.filters = []
    }
    if(this.role !== "SuperAdmin"){
      this.filters = [
        {
          "key": 'USER_ID',
          "value": this.employeeId.toString()
        }
      ]
    }
    this.WorklogService.getWorklogs(this.filters ? this.filters : [], this.pageNumber, this.pageSize,this.sortingCol,this.direction).subscribe((data: any) => {
        if(data){
          this.tableLists = data?.responseObject?.content;
          this.totalCount = data?.responseObject?.totalElements;
          this.selectedData = []
          this.tableLists.forEach((el:any)=>{
            if(el.minutes){
              el.convertedLoggedTime = this.sharedService.convertMinutesToTime(el.minutes)
            }
          })
        }
      },err => {
        // console.log(err);
        this.tableLists = []
      });
  }

  exportTable() {
    if (this.sharedTable) {
      this.sharedTable.exportToCSV('Worklog');
    }
  }

}
